import React from 'react';
import { Col, Container, Row } from "react-bootstrap";

const Perks = () => {
    return (
        <div className="Perks p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={10} lg={10} xl={10} xxl={10} className="m-auto text-center">
                        <h2>Benefits of  Using TekRevol’s IP Protection Services</h2>
                        <p>Choose TekRevol for robust Intellectual Property protection. Our services extend beyond basic security, acting as a proactive shield to ensure comprehensive protection for your innovations, brands, and creative works.</p>
                    </Col>
                </Row>
                <Row className="h-100 perks-padd">
                    <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-lg-5 mb-xl-0">
                        <div className="perks-box">
                            <div className="perks-content">
                                <h4>Expert Guidance and Consultation</h4>
                                <p>Rely on TekRevol's experts for complete guidance and strategic consultation. We navigate the complexities of IP protection with confidence and clarity.</p>
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-lg-5 mb-xl-0">
                        <div className="perks-box">
                            <div className="perks-content">
                                <h4>Global Reach and Coverage</h4>
                                <p>Access a global network of protection with our services, securing your intellectual assets across various countries and regions to support your business expansion.</p>
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
                        <div className="perks-box">
                            <div className="perks-content">
                                <h4>Efficient Dispute Resolution</h4>
                                <p>Ensure transparency throughout development with our open procedures, keeping you informed at every phase via innovative project management tools.</p>
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
                        <div className="perks-box">
                            <div className="perks-content">
                                <h4>Customized Solutions for Every Industry</h4>
                                <p>Get industry-specific IP protection solutions, crafted to address the unique challenges and opportunities within your specific business sector, ensuring maximum value.</p>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default Perks